module.exports = __webpack_public_path__ + "static/media/footerlogo.1a27ecfe.png";